import React from "react";
import { Box, Typography } from "@mui/material";
import PopupModal from "../../shared/PopupModal";
import DemoInputInfoLink from "./DemoInputInfoLink";
import { buildDemoRegisterModalContent } from "../utils/demoRegisterModalContent";

// デモ（TOPページ埋め込み）で本登録が必要になったときに出す誘導モーダル。

// 保存に失敗しているときは INTRO の代わりに出す。
// 引き継げないことと、やり直したい場合の手順を確定前に伝える
const SAVE_FAILED_INTRO = (
  <>
    ブラウザの設定や保存容量の不足などにより、最新の入力内容をこのブラウザに保存できていません。そのため、このまま進んでも入力内容の一部または全部が本登録に引き継がれません。
    <br />
    以前に保存できた内容が残っている場合は、その時点の内容が「デモプロジェクト」として登録されます。
    <br />
    やり直す場合は「デモ入力を続ける」を選び、デモ画面の「入力をリセット」で入力内容を削除してから、もう一度入力してください。
  </>
);

const INTRO = (
  <>
    本登録すると、このブラウザに保存されたデモ入力内容を「デモプロジェクト」として登録できます。
    <br />
    入力は空欄や途中の状態でも問題ありません。
  </>
);

// transferOnly: 引き継ぎが動く前提の説明。保存できていないときは成り立たないので出さない
const NOTES = [
  { text: "入力内容は、この端末・ブラウザに保存されます", transferOnly: true },
  { text: "PDF生成時を除き、デモ利用中は当社サーバーへ送信されません" },
  {
    text: "別端末・別ブラウザには引き継げないため、同じ端末・同じブラウザで本登録してください",
    transferOnly: true,
  },
  {
    text: "本登録が完了すると、デモ入力内容は「デモプロジェクト」としてDBへ保存されます",
    transferOnly: true,
  },
  { text: "通常の新規登録画面から登録した場合は、デモ入力内容を引き継ぎません" },
];

export default function DemoRegisterModal({
  open,
  onClose,
  onConfirm,
  reason = "save",
  saveFailed = false,
}) {
  const { title, lead, confirmLabel, showTransferNotes } =
    buildDemoRegisterModalContent({ reason, saveFailed });
  const notes = showTransferNotes
    ? NOTES
    : NOTES.filter((note) => !note.transferOnly);

  return (
    <PopupModal
      open={open}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      confirmLabel={confirmLabel}
      cancelLabel="デモ入力を続ける"
    >
      <Typography
        sx={{
          fontSize: "0.875rem",
          mb: 1.5,
          color: saveFailed ? "error.main" : undefined,
        }}
      >
        {lead && (
          <>
            {lead}
            <br />
          </>
        )}
        {saveFailed ? SAVE_FAILED_INTRO : INTRO}
      </Typography>
      <Box
        component="ul"
        sx={{
          listStyle: "none",
          pl: 0,
          m: 0,
          fontSize: "0.8125rem",
          color: "#4b5563",
        }}
      >
        {notes.map((note) => (
          <Box
            component="li"
            key={note.text}
            sx={{
              position: "relative",
              pl: "1.2em",
              mb: 0.5,
              // LP 側のリセット（.top li { list-style: none }）で ・ が消えるため自前で描画
              "&::before": {
                content: '"・"',
                position: "absolute",
                left: 0,
              },
            }}
          >
            {note.text}
          </Box>
        ))}
      </Box>
      <Typography sx={{ fontSize: "0.75rem", mt: 2 }}>
        <DemoInputInfoLink />
      </Typography>
    </PopupModal>
  );
}
